import { Injectable, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SignalTriggerUtilitiesService {
  public static trigger(flag: WritableSignal<boolean>, value = true): void {
    flag.set(value);

    setTimeout(() => {
      flag.set(!value);
    });
  }
}
